// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__egtMf","control":"styles_control__QGEcK"};